// eslint-disable-next-line
export default (res) => res.json();
